import { render, staticRenderFns } from "./JsonData.vue?vue&type=template&id=38312f8f&scoped=true&"
import script from "./JsonData.vue?vue&type=script&lang=js&"
export * from "./JsonData.vue?vue&type=script&lang=js&"
import style0 from "./JsonData.vue?vue&type=style&index=0&id=38312f8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38312f8f",
  null
  
)

export default component.exports